export default __webpack_public_path__ + "static/images/investing.0749e70a.png";